import { RuntimeMediaQuery } from '@duda-co/responsive-styles/RuntimeMediaQuery';
import type { ResponsiveStylesStructured } from '@duda-co/responsive-styles/types/ResponsiveStylesTypes';
import { Div } from 'client/widget-components/basicComponents';
import {
    mergeResponsiveStyles,
    nestResponsiveStyles,
} from 'client/widget-components/responsive-styles/responsiveStylesService';
import type { CSSProperties } from 'react';
import React, { FC } from 'react';
import { SearchDropdown } from '../SearchDropdown/SearchDropdown';
import { SearchInput } from '../SearchInput/SearchInput';
import type { SearchPopupContentProps } from '../types';

export const SearchPopupContentRound: FC<SearchPopupContentProps> = ({
    inputRef,
    styles,
    placeholder,
    inputValue,
    onInputChange,
    onInputFocus,
    onClosePopup,
    collections,
    isResultsShown,
    isLoading,
    fetchMore,
    animatedBlockRef,
    animationState,
}) => (
    <Div
        styles={[contentDefaultStyles, styles?.popup]}
        ref={animatedBlockRef}
        style={TRANSITION_STYLES[animationState]}
        data-grab='collection-search-widget-popup'
    >
        <SearchInput
            inputRef={inputRef}
            styles={{
                ...styles,
                input: mergeResponsiveStyles([inputStyles, styles?.input]),
                inputWrapper: inputWrapperStyles,
                closeBtn: closeBtnStyles,
            }}
            value={inputValue}
            placeholder={placeholder}
            onChange={onInputChange}
            onFocus={onInputFocus}
            onClose={onClosePopup}
        />
        <SearchDropdown
            collections={collections}
            styles={{
                ...styles,
                dropdownItem: nestResponsiveStyles(dropdownFirstItemStyles, {
                    innerSelector: ':first-child',
                }),
            }}
            isResultsShown={isResultsShown}
            isLoading={isLoading}
            fetchMore={fetchMore}
        />
    </Div>
);

const TRANSITION_STYLES: Record<string, CSSProperties> = {
    entering: { marginTop: '56px', opacity: 1 },
    entered: { marginTop: '56px', opacity: 1 },
    exiting: { marginTop: '-200px', opacity: 0 },
    exited: { marginTop: '-200px', opacity: 0, height: 0, overflow: 'hidden' },
};

const dropdownFirstItemStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        marginBlockStart: '32px',
    },
};

const inputWrapperStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        padding: 0,
        position: 'relative',
    },
    [RuntimeMediaQuery.MOBILE]: {
        padding: 0,
    },
    [RuntimeMediaQuery.TABLET]: {
        padding: 0,
    },
};

const inputStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        border: 'none',
        padding: '16px',
        paddingInlineEnd: '48px',
        borderRadius: '38px',
        height: '56px',
        background: 'white',
    },
};

const closeBtnStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        width: '14px',
        height: '14px',
        position: 'absolute',
        right: '24px',
        top: '50%',
        transform: 'translateY(-50%)',
    },
};

const contentDefaultStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        position: 'relative',
        background: '#F5F5F7',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '30px',
        padding: '8px',
        maxHeight: 'calc(100vh - 112px)',
        width: '40%',
        transition: `all 0.2s linear`,
        marginTop: '100px',
        marginInline: 'auto',
        opacity: 0,
    },
    [RuntimeMediaQuery.TABLET]: {
        width: '80%',
    },
    [RuntimeMediaQuery.MOBILE]: {
        width: '90%',
    },
};
